import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { NotFound } from "../../components/modules/NotFound";
import { AUTH_ROOT_ROUTE, LOGIN_ROUTE } from "routes/auth/authPaths";
import authRoutesConfig from "./authRoutesConfig";
import { getRoutesProps } from "../getRoutesProps";

const AuthRoutes = () => (
  <Switch>
    <Redirect path="/auth" to={AUTH_ROOT_ROUTE + LOGIN_ROUTE} exact />
    {getRoutesProps({ route: authRoutesConfig }).map((routeProps) => (
      <Route
        key={routeProps.label}
        path={routeProps.path}
        exact
        component={routeProps.component}
      />
    ))}
    <Route component={NotFound} />
    <Redirect from="*" to={AUTH_ROOT_ROUTE} />
  </Switch>
);

export default AuthRoutes;
